import { lazy } from 'react';

const Processor = lazy(() => import('./ProcessorPage'));

const ProcessorConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'processor/login',
      element: <Processor />,
    },
  ],
};

export default ProcessorConfig;
